import { engineComponent } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { PlayList } from "../Components/Sounds/PlayList";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { Symbols } from "../GameComponents/Symbols";
import { Paylines } from "../GameComponents/Paylines";
import { BetManager } from "../Managers/BetManager";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { AnimationElement } from "../Components/Elements/Graphics/AnimationElement";
import { ModuleManager } from "../Managers/ModuleManager";
import { CustomUtils } from "../Utils/CustomUtils";
import { Payline } from "../GameComponents/Payline";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimator2 extends WinAnimator {
    static Symbols: Array<Array<Symbol>> = [
        [null, null, null],
        [null, null, null],
        [null, null, null],
        [null, null, null],
        [null, null, null],
    ];

    static OutroToPickDelay: number = 8;

    static Force: boolean = false;

    private _highWinsAnims: SwitchElement;

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        highWinsAnims?: SwitchElement,
    ): void {
        if (highWinsAnims != null) {
            this._highWinsAnims = highWinsAnims;
        }
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        this.tease(reelIndex);
        this.moveToTop();
    }

    public showSymbols(reelsData: Array<Communication.Game.IReel>): void {
        super.showSymbols(reelsData);
        this.moveToTop();
    }

    private tease(reelIndex: number): void {
        const count = this.countScatters(reelIndex);

        if (count >= this.getMinTeasingSymbolCount()) {
            this.tease3(reelIndex, count);
        } else if (count === this.getMinTeasingSymbolCount() - 1) {
            const helpCount = reelIndex > 0 ? this.countScatters(reelIndex - 1) : 0;

            if (helpCount === count) {
                this.tease3(reelIndex, count);
            } else {
                this.tease2(reelIndex, count);
            }
        } else {
            this.tease1(reelIndex, count);
        }
    }

    private countScatters(reelIndex: number): number {
        let count = 0;

        for (let i = 0; i <= reelIndex; i++) {
            if (this.currentReels[i].symbols.indexOf(this.getTeasingSymbol()) !== -1) {
                count++;
            }
        }

        return count;
    }

    private tease1(reelIndex: number, count: number): void {
        if (this.reelCount - reelIndex - 1 < this.getMinTeasingSymbolCount() - count) {
            return;
        }

        const symbolIndex = this.currentReels[reelIndex].symbols.indexOf(this.getTeasingSymbol());

        if (symbolIndex != -1) {
            if (this.allowSymbolGoToCase(reelIndex, symbolIndex, Symbol.CaseImpact)) {
                this.currentSymbols[reelIndex][symbolIndex].goToCase(Symbol.CaseImpact);
                PlayList.play("SND_BaseScatter0" + (reelIndex + 1));
            }
        }
    }

    private tease2(reelIndex: number, count: number): void {
        if (this.reelCount - reelIndex - 1 < this.getMinTeasingSymbolCount() - count) {
            for (let i = 0; i < reelIndex; i++) {
                for (let j = 0; j < this.currentSymbols[i].length; j++) {
                    if (this.allowSymbolGoToCase(i, j, Symbol.CaseNormal)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNormal);
                    }
                }
            }

            return;
        }

        for (let i = 0; i < reelIndex; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                if (this.currentSymbols[i][j].id === this.getTeasingSymbol() - 1) {
                    if (!WinAnimator2.Force && this.allowSymbolGoToCase(i, j, Symbol.CaseTease)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseTease);
                        PlayList.play("SND_BaseScatter0" + (reelIndex + 1));
                    } else {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseImpact);
                        PlayList.play("SND_BaseScatter0" + (reelIndex + 1));
                    }
                } else {
                    if (!WinAnimator2.Force && this.allowSymbolGoToCase(i, j, Symbol.CaseNowin)) {
                        this.currentSymbols[i][j].goToCase(Symbol.CaseNowin);
                    }
                }
            }
        }

        this.tease3(reelIndex, count);
    }

    private tease3(reelIndex: number, count: number): void {
        for (let i = 0; i < this.currentSymbols[reelIndex].length; i++) {
            if (this.currentSymbols[reelIndex][i].id === this.getTeasingSymbol() - 1) {
                if (!WinAnimator2.Force && this.allowSymbolGoToCase(reelIndex, i, Symbol.CaseImpactTease)) {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpactTease);
                    PlayList.play("SND_BaseScatter0" + (reelIndex + 1));
                } else {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseImpact);
                    PlayList.play("SND_BaseScatter0" + (reelIndex + 1));
                }
            } else {
                if (!WinAnimator2.Force && this.allowSymbolGoToCase(reelIndex, i, Symbol.CaseNowin)) {
                    this.currentSymbols[reelIndex][i].goToCase(Symbol.CaseNowin);
                }
            }
        }
    }

    private getTeasingSymbol(): number {
        return 10;
    }

    private getMinTeasingSymbolCount(): number {
        return 3;
    }

    public showInitWins(wins: Array<Communication.Game.IWin>, win: number): void {
        this.currentWins = wins;
        this.currentWin = win;

        this.resetAnimations();

        if (wins != null && wins.length > 0) {
            this.dynamicTint();
            this.currentMultiplierIndex = 0;

            for (let i = 0; i < this.multipliers.length; i++) {
                if (this.currentWin / BetManager.Bet >= this.multipliers[i]) {
                    this.currentMultiplierIndex = i;
                }
            }
            for (let i = 0; i < this.currentWins.length; i++) {
                this.winSymbolsGoToCase(i, "START_CYCLE", false);
            }
            this.showCustomInitWin();
            this.showFirstInitWins();
            this.finishFirstInitWins();
            this.moveToTop();
        } else {
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
            this.moveToTop();
        }
    }

    public showWins(wins: Array<Communication.Game.IWin>, win: number): boolean {
        this.currentWins = wins;
        this.currentWin = win;

        this.resetAnimations();

        if (wins != null && wins.length > 0) {
            if (ModuleManager.pickEnabled()) {
                PlayList.loop("SND_FSWinLoop");
            }
            this.dynamicTint();
            this.currentMultiplierIndex = 0;

            for (let i = 0; i < this.multipliers.length; i++) {
                if (this.currentWin / BetManager.Bet >= this.multipliers[i]) {
                    this.currentMultiplierIndex = i;
                }
            }

            if (!this.showCustomWin()) {
                this.showFirstWins();
            }
            this.moveToTop();
            return this.currentMultiplierIndex >= 3;
        } else {
            this.allSymbolsGoToCase(Symbol.CaseNormal, false);
            this.startTimer(WinAnimator.Idle, this.getInitialIdleDelay());
            this.moveToTop();
            return false;
        }
    }

    protected startAnimation(): void {
        super.startAnimation();
    }

    protected finishFirstWins(): void {
        if (ModuleManager.pickEnabled()) {
            this.emit(WinAnimator.FinishWinAnimator);
            return;
        }

        // for (let i = 0; i < this.currentWins.length; i++) {
        //     this.winSymbolsGoToCase(i, 'START_CYCLE', false);
        // }

        super.finishFirstWins();
    }

    protected finishFirstInitWins(): void {
        if (ModuleManager.pickEnabled()) {
            this.emit(WinAnimator.FinishWinAnimator);
            return;
        }

        super.finishFirstInitWins();
    }

    protected winSymbolsGoToCaseAsPayline(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        if (this.paylines != null) {
            const definition = PaylinesDefinitions.getPaylineDefinitionsById(
                win.paylineId,
                this.paylines.paylineDefinition,
            );

            for (let i = 0; i < definition.length; i++) {
                if (win.mask[i] === 1 && this.allowSymbolGoToCase(i, definition[i], caseType)) {
                    const symbol = this.currentSymbols[i][definition[i]];
                    let index: number = this.getAnimationIndex() + 1;

                    if (caseType === Symbol.CaseWin) {
                        symbol.goToCase(Symbol.CaseWin + "_" + i);
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    protected winSymbolsGoToCaseAsScatter(winIndex: number, caseType: string): Array<Symbol> {
        const win = this.currentWins[winIndex];
        const symbols: Array<Symbol> = [];

        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if ((win.mask[i] & (1 << j)) !== 0 && this.allowSymbolGoToCase(i, j, caseType)) {
                    const symbol = this.currentSymbols[i][j];
                    let index: number = this.getAnimationIndex() + 1;

                    if (caseType === Symbol.CaseWin) {
                        if (index > 3) {
                            symbol.goToCase(caseType);
                        } else {
                            symbol.goToCase(caseType + "_" + index);
                        }
                    } else {
                        symbol.goToCase(caseType);
                    }

                    this.symbolsContainer.addChild(symbol);

                    symbols.push(symbol);
                }
            }
        }

        return symbols;
    }

    protected winPaylineGoToCase(winIndex: number, caseType: string): void {
        if (this.paylines != null) {
            const win = this.currentWins[winIndex];

            if (win.trigger === Communication.Game.WinTrigger.Payline) {
                this.paylines.goToCase(caseType, win.paylineId);
            }
        }
    }

    public reset(showLastSymbols: boolean): boolean {
        if (this._highWinsAnims != null) {
            this._highWinsAnims.goToCase("NORMAL");
        }
        return super.reset(showLastSymbols);
    }

    protected allowSymbolGoToCase(reelIndex: number, symbolIndex: number, caseType: string): boolean {
        if (
            this.currentSymbols[reelIndex][symbolIndex].getCurrentCase() === Symbol.CaseIdle &&
            caseType === Symbol.CaseNormal
        ) {
            return false;
        }

        return true;
    }

    private dynamicTint(id: number = null): void {
        let winId: number = id;
        if (winId == null) {
            let highestWin: Communication.Game.IWin = null;

            for (let i: number = 0; i < this.currentWins.length; i++) {
                if (highestWin == null) {
                    highestWin = this.currentWins[i];
                } else {
                    let nextWin: Communication.Game.IWin = this.currentWins[i];
                    if (nextWin.amount > highestWin.amount) {
                        highestWin = nextWin;
                    }
                }
            }
            if (highestWin != null && highestWin.payoutId != null) {
                winId = highestWin.payoutId;
            }
        }

        if (winId != null) {
            switch (winId) {
                case 1:
                    AnimationElement.DynamicTint = "ff0000";
                    ImageElement.DynamicTint = "ff0000";
                    break;
                case 2:
                    AnimationElement.DynamicTint = "ffff00";
                    ImageElement.DynamicTint = "ffff00";
                    break;
                case 3:
                    AnimationElement.DynamicTint = "fe6702";
                    ImageElement.DynamicTint = "fe6702";
                    break;
                case 4:
                    AnimationElement.DynamicTint = "c600ff";
                    ImageElement.DynamicTint = "c600ff";
                    break;
                case 5:
                    AnimationElement.DynamicTint = "77ff00";
                    ImageElement.DynamicTint = "77ff00";
                    break;
                case 6:
                    AnimationElement.DynamicTint = "e71744";
                    ImageElement.DynamicTint = "e71744";
                    break;
                case 7:
                    AnimationElement.DynamicTint = "fefe00";
                    ImageElement.DynamicTint = "fefe00";
                    break;
                case 8:
                    AnimationElement.DynamicTint = "009fff";
                    ImageElement.DynamicTint = "009fff";
                    break;
                case 9:
                    AnimationElement.DynamicTint = "ff0000";
                    ImageElement.DynamicTint = "ff0000";
                    break;
                default:
                    AnimationElement.DynamicTint = "ff0000";
                    ImageElement.DynamicTint = "ff0000";
            }
        }
    }

    protected addCurrentSymbol(reelIndex: number, symbolIndex: number): void {
        if (this.currentSymbols[reelIndex][symbolIndex] === null) {
            const id = this.currentReels[reelIndex].symbols[symbolIndex];

            const symbol = this.symbols.getSymbol(id - 1, Symbol.CaseNormal);
            symbol.position.x = this.reelX[reelIndex] - symbol.offsetX;
            symbol.position.y = this.reelY[reelIndex] + this.symbolHeight * symbolIndex - symbol.offsetY;
            if (WinAnimator2.Symbols != null) {
                if (WinAnimator2.Symbols[reelIndex] != null) {
                    WinAnimator2.Symbols[reelIndex][symbolIndex] = symbol;
                }
            }

            this.symbolsContainer.addChild(symbol);

            this.currentSymbols[reelIndex][symbolIndex] = symbol;
        }
    }

    //******************************************************************************************************************
    //  OUTRO TO PICK
    //******************************************************************************************************************

    public outroToPick(): void {
        const scatterWinIndex = this.getScatterWinIndex();
        if (scatterWinIndex == -1) {
            return;
        }
        const scatterReels = this.getReelsWithScatter(scatterWinIndex);

        this.allSymbolsGoToCase(Symbol.CaseNowin, false);
        this.allPaylinesGoToCase(Payline.CaseNowin);
        for (let i = 0; i < scatterReels.length; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                const symbol = this.currentSymbols[scatterReels[i]][j];

                if (symbol != null) {
                    symbol.setDynamicTime(WinAnimator2.OutroToPickDelay * i);
                    symbol.goToCase("OUTRO_PICK");
                }
            }
        }
    }

    protected getScatterWinIndex(): number {
        for (let i = 0; i < this.currentWins.length; i++) {
            if (this.currentWins[i].trigger == Communication.Game.WinTrigger.Scatter) {
                return i;
            }
        }

        return -1;
    }

    protected getReelsWithScatter(scatterWinIndex: number): Array<number> {
        const reelIndexes: Array<number> = [];
        const win = this.currentWins[scatterWinIndex];

        for (let i = 0; i < this.reelCount; i++) {
            if (win.mask[i] != 0) {
                reelIndexes.push(i);
            }
        }

        return reelIndexes;
    }

    protected moveToTop(): void {
        for (let i = 0; i < this.currentSymbols.length; i++) {
            for (let j = 0; j < this.currentSymbols[i].length; j++) {
                const symbol = this.currentSymbols[i][j];

                if (symbol !== null && symbol.id === 9) {
                    symbol.parent.addChild(symbol);
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimator2.ts
 **/